{
    "Accessibility menu": "barrierefreiheits-menü",
    "Reset settings": "Einstellungen Zurücksetzen",
    "Close": "Schließen",
    "Content adjustments": "Inhaltsanpassungen",
    "Navigation adjustments": "Navigationsanpassungen",
    "Align Left": "Links ausrichten",
    "Adjust Font Size": "Schriftgröße anpassen",
    "Highlight Title": "Titel hervorheben",
    "Highlight Links": "Links hervorheben",
    "Readable Font": "Lesbare Schriftart",
    "Colour adjustments": "Farbanpassungen",
    "Dark Contrast": "Dunkler Kontrast",
    "Light Contrast": "Heller Kontrast",
    "High Contrast": "Hoher Kontrast",
    "High Saturation": "Hohe Sättigung",
    "Low Saturation": "Niedrige Sättigung",
    "Monochrome": "Monochrom",
    "Tools": "Werkzeuge",
    "Reading Guide": "Leseführung",
    "Stop Animations": "Animationen stoppen",
    "Big Cursor": "Großer Cursor",
    "Increase Font Size": "Schriftgröße vergrößern",
    "Decrease Font Size": "Schriftgröße verkleinern",
    "Letter Spacing": "Buchstabenabstand",
    "Line Height": "Zeilenhöhe",
    "Font Weight": "Schriftschnitt",
    "Dyslexia Font": "Legasthenie-Schriftart",
    "Language": "Sprache",
    "Accessibility widget": "barrierefreiheits-menü öffnen",
    "Accessibility Profiles": "Barrierefreiheits-Profile",
    "Cognitive Disability": "Kognitive Beeinträchtigung",
    "Seizure Safe": "Anfallssicher",
    "Accessibility statement": "Barrierefreiheits-Erklärung"
}